import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=1e8e5a36&scoped=true&"
import script from "./addCategory.vue?vue&type=script&lang=js&"
export * from "./addCategory.vue?vue&type=script&lang=js&"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=1e8e5a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e5a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8e5a36')) {
      api.createRecord('1e8e5a36', component.options)
    } else {
      api.reload('1e8e5a36', component.options)
    }
    module.hot.accept("./addCategory.vue?vue&type=template&id=1e8e5a36&scoped=true&", function () {
      api.rerender('1e8e5a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/list/addCategory.vue"
export default component.exports